import register from './register'

export default {
    register
}



// WEBPACK FOOTER //
// ./src/api/pub/sms/index.js